// HowItWorks.jsx
import React from "react";
import "../css/HowItWorks.css";

/**
 * Usage:
 * <HowItWorks
 *   onGetStarted={() => {}}
 *   items={[
 *     { title: "Bye-bye Fees", desc: "With our software, all the processing fees will be incorporated into the sale and a small fee is passed on to the card holder.", icon: <YourIcon/> },
 *     ...
 *   ]}
 * />
 */
export default function HowItWorks({

   onCtaClick,
  title = "How\nIt works?",
  ctaText = "GET STARTED",
  onGetStarted,
  items,
}) {
  const defaultItems = [
    {
      title: "Bye-bye Fees",
      desc: "With our software, all the processing fees will be incorporated into the sale and a small fee is passed on to the card holder.",
      icon: <PiggyIcon />,
    },
    {
      title: "Cash is King",
      desc: "Even better, your customers are rewarded for paying in cash with a 3.99% discount!",
      icon: <CashIcon />,
    },
    {
      title: "A Bigger Slice",
      desc: "You, the business owner, get 100% of the sale and at the end of the month, your processing fees will be ZERO!",
      icon: <PieIcon />,
    },
    {
      title: "Signs of the Times!",
      desc: "Point-of-purchase pricing and discount signage clearly spell out the process to customers",
      icon: <SignIcon />,
    },
  ];

  const data = items?.length ? items : defaultItems;

  return (
    <section className="hiw" aria-label="How it works">
      <div className="hiw__wrap">
        <div className="hiw__card">
          {/* Left column */}
          <div className="hiw__left">
            <h2 className="hiw__title">
              {title.split("\n").map((line, i) => (
                <span key={i} className="hiw__titleLine">
                  {line}
                </span>
              ))}
            </h2>

            <button className="hiw__cta" type="button"  onClick={onCtaClick || (() => (window.location.hash = "products"))}>
              {ctaText}
              <span className="hiw__arrow" aria-hidden="true">
                ›
              </span>
            </button>
          </div>

          {/* Items */}
          <div className="hiw__items" role="list">
            {data.map((it, idx) => (
              <div className="hiw__item" role="listitem" key={idx}>
                <div className="hiw__icon">{it.icon}</div>
                <div className="hiw__itemTitle">{it.title}</div>
                <div className="hiw__itemDesc">{it.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ---------- inline SVG icons (simple, similar vibe) ---------- */
function PiggyIcon() {
  return (
    <svg viewBox="0 0 80 80" className="hiw__svg" aria-hidden="true">
      <path
        d="M18 44c0-10 10-18 24-18 10 0 18 4 22 10l6 1v8l-6 1c-3 8-12 13-22 13H31c-7 0-13-6-13-15Z"
        fill="#FF6B6B"
      />
      <circle cx="49" cy="37" r="2.4" fill="#1f2452" opacity=".85" />
      <path d="M31 59v6M47 59v6" stroke="#1f2452" strokeWidth="4" strokeLinecap="round" opacity=".25" />
      <path d="M62 28c4 3 6 7 6 12" stroke="#FF6B6B" strokeWidth="6" strokeLinecap="round" />
      <circle cx="30" cy="24" r="9" fill="#FF8F8F" />
      <circle cx="62" cy="22" r="8" fill="#FBBF24" />
      <path d="M62 16v12" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M56 22h12" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function CashIcon() {
  return (
    <svg viewBox="0 0 80 80" className="hiw__svg" aria-hidden="true">
      <path d="M18 28l22-12 22 12-22 12-22-12Z" fill="#34D399" />
      <path d="M18 28v28l22 12V40L18 28Z" fill="#10B981" />
      <path d="M62 28v28L40 68V40l22-12Z" fill="#22C55E" />
      <circle cx="28" cy="52" r="10" fill="#FBBF24" />
      <path d="M28 46v12" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M24 49c0-2 2-4 4-4s4 1 4 3-2 3-4 3-4 1-4 3 2 4 4 4 4-1 4-3" stroke="#fff" strokeWidth="3" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function PieIcon() {
  return (
    <svg viewBox="0 0 80 80" className="hiw__svg" aria-hidden="true">
      <circle cx="40" cy="42" r="20" fill="#CBD5E1" />
      <path d="M40 22a20 20 0 0 1 20 20H40V22Z" fill="#60A5FA" />
      <path d="M14 62c6-6 14-10 26-10s20 4 26 10" stroke="#1f2452" strokeWidth="3" opacity=".15" />
    </svg>
  );
}

function SignIcon() {
  return (
    <svg viewBox="0 0 80 80" className="hiw__svg" aria-hidden="true">
      <rect x="18" y="18" width="44" height="36" rx="10" fill="#E5E7EB" />
      <path d="M28 28h24M28 36h18M28 44h14" stroke="#9CA3AF" strokeWidth="3" strokeLinecap="round" />
      <circle cx="52" cy="30" r="8" fill="#FB7185" />
      <path d="M52 25v10" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M47 30h10" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M40 54v12" stroke="#1f2452" strokeWidth="4" strokeLinecap="round" opacity=".25" />
    </svg>
  );
}